import styled from 'styled-components';

export const ContentWrapperStyled = styled.div`
	position: absolute;
	width: 50%;
	height: 100%;
	overflow: none;
	display: flex;
	flex-direction: column;
	padding: 0;
	margin: 0;
	background: ${({ theme }) => theme.colors.primaryColor};
	color: white;
	z-index: 9;

	transition: transform 350ms;
	transform: translateX(0%);
	@media (max-width: ${({ theme }) => `${theme.variables.breakPoint}px`}) {
		transform: translateY(0%);
	}

	&.closed {
		transform: translateX(-100%);
		@media (max-width: ${({ theme }) => `${theme.variables.breakPoint}px`}) {
			transform: translateY(100%);
		}
	}

	@media (max-width: ${({ theme }) => `${theme.variables.breakPoint}px`}) {
		position: relative;
		width: 100%;
	}
`;

export const CloseContainerStyled = styled.div`
	position: relative;
	display: flex;
	justify-content: space-between;
	padding: ${({ theme }) => theme.variables.padding * 0.5}px;
	padding-left: ${({ theme }) => theme.variables.padding}px;
`;

export const ContentContainerStyled = styled.div`
	padding: ${({ theme }) => theme.variables.padding}px;
	padding-top: 0;
	overflow-y: auto;
`;

export const MobileRemoteContainerStyled = styled.div`
	padding: ${({ theme }) => theme.variables.padding * 0.25}px;
	background: ${({ theme }) => theme.colors.tertiaryColor};
`;
